import VueComponents from '@nn/vue-components';
import Vue from 'vue';
import { createVueChildContainer } from '../app-vue-shared/createVueChildContainer';
import createRouter from './router';
import App from './App';

Vue.use(VueComponents);

export default function bootstrapCoupleEherkenning(root, config) {
  return new Vue({
    router: createRouter(),
    el: createVueChildContainer(root),
    render: (h) => h(App, {
      props: {
        config,
      },
    }),
  });
}
